<div class="user-detail-card user-detail-view-card half-row new-connections-card">
  <h5 class="card-title">
    {{ title }}
    <span class="connections-count">{{ connectedCount }}/{{ totalSlots }}</span>
  </h5>

  <div class="connections-grid" *ngIf="hasConnections; else emptyState">
    <div class="connection-row" *ngIf="pendingConnections.length">
      <div class="row-header">
        No Action <span class="row-count">({{ pendingCount }})</span>
      </div>
      <div class="avatar-list">
        <a *ngFor="let connection of pendingConnections" class="connection-avatar pending"
          [title]="avatarLabel(connection)" [attr.aria-label]="avatarLabel(connection)"
          [attr.href]="profileUrl(connection)" target="_blank" rel="noopener noreferrer">
          <img [src]="avatarSource(connection)" [alt]="avatarLabel(connection)" />
        </a>
      </div>
    </div>

    <div class="row-divider" *ngIf="showDivider"></div>

    <div class="connection-row" *ngIf="mutualConnections.length">
      <div class="row-header">
        Mutual Matches <span class="row-count">({{ mutualCount }})</span>
      </div>
      <div class="avatar-list">
        <a *ngFor="let connection of mutualConnections" class="connection-avatar mutual"
          [title]="avatarLabel(connection)" [attr.aria-label]="avatarLabel(connection)"
          [attr.href]="profileUrl(connection)" target="_blank" rel="noopener noreferrer">
          <img [src]="avatarSource(connection)" [alt]="avatarLabel(connection)" />
        </a>
      </div>
    </div>

    <div class="row-divider"></div>

    <div class="connection-row" *ngIf="upcomingConnections.length">
      <div class="row-header">
        Upcoming Matches <span class="row-count">({{ upcomingCount }})</span>
      </div>
      <div class="avatar-list avatar-list-scrollable">
        <a *ngFor="let connection of upcomingConnections" class="connection-avatar upcoming"
          [title]="avatarLabel(connection)" [attr.aria-label]="avatarLabel(connection)"
          [attr.href]="profileUrl(connection)" target="_blank" rel="noopener noreferrer">
          <img [src]="avatarSource(connection)" [alt]="avatarLabel(connection)" />
        </a>
      </div>
    </div>


  </div>

  <ng-template #emptyState>
    <div class="empty-message">
      No connections to show yet.
    </div>
  </ng-template>
</div>